import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';
import classnames from 'classnames';
import { Buttons } from 'lidya-common-components';
import { findImage } from '../../common/imageLoader';
import './sign.up.less';
import { SignUpButton } from './sign.up.button';
import { ModalDataProvider } from '../../common/providers/modalProvider/modalDataProvider.provider';
import { SignUpModalComponent } from './sign.up.modal.component';
import { useGlobalData } from '../../../providers/globalDataProvider/globalDataProvider.useGlobalData';

const getImage = ({ imageName, country }) => {
  let leftImage = findImage(imageName);
  if (leftImage.src === '') {
    leftImage = findImage(`signup_${country}`);
  }
  if (leftImage.src === '') {
    leftImage = findImage('signup');
  }
  return leftImage;
};

const ImageComponent = ({ image }) => {
  const { country } = useGlobalData();
  const imageToUse = getImage({ imageName: image, country });
  return <GatsbyImage image={imageToUse} alt="Sign Up Image" />;
};
ImageComponent.propTypes = {
  image: PropTypes.string.isRequired,
};

const SignUpModal = ({
  id,
  type,
  className,
  btnClass,
  label,
  withButton,
  signupType,
  isCreateAccount,
  // forceShow,
}) => (
  <ModalDataProvider>
    <div className={classnames(className)}>
      {withButton && (
        <SignUpButton
          type={Buttons.BUTTON_TYPES[type] || Buttons.BUTTON_TYPES.PRIMARY}
          className={btnClass}
          label={label}
          id={`SignUpModalButtonFromModal${id}`}
        />
      )}
      <SignUpModalComponent
        isCreateAccount={isCreateAccount}
        signupType={signupType}
        // forceShow={forceShow}
      />
    </div>
  </ModalDataProvider>
);

SignUpModal.propTypes = {
  id: PropTypes.string,
  btnClass: PropTypes.string,
  className: PropTypes.string,
  forceShow: PropTypes.bool,
  isCreateAccount: PropTypes.bool,
  label: PropTypes.string,
  signupType: PropTypes.string,
  type: PropTypes.string,
  withButton: PropTypes.bool,
};

SignUpModal.defaultProps = {
  id: '',
  type: 'SECONDARY',
  className: '',
  btnClass: '',
  label: 'web.navigation.sign.up',
  withButton: true,
  signupType: undefined,
  isCreateAccount: false,
  forceShow: false,
};

export default SignUpModal;
